<template>
    <TextButton title="Offerten" link="/offers" id="offers-subnavigationTitle" />
    <div class="my-1 flex flex-wrap justify-between">
        <div class="lg:w-1/2 w-full">
            <FullButton
                title="Erweiterte Suche"
                link="/offers/search/0"
                width="95"
                colour="red"
                id="offers-subnavigationButton1"
            />
        </div>
        <div class="lg:w-1/2 w-full text-right">
            <FullButton
                title="nanoo.pro Cloud Services"
                link="#"
                width="95"
                colour="blue"
                id="offers-subnavigationButton2"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import FullButton from '@/components/Buttons/FullButton.vue'
    import TextButton from '@/components/Buttons/TextButton.vue'
</script>
